module.exports = __webpack_public_path__ + "static/img/upload.e0684df1.svg";